
export interface ImportRegelDto {
    maxZuordnungsAenderungen: number;
    netzverknuepfungsgrenzwert: number;
    limitAenderungLeistung: number;
}

export type ImportRegelFieldType = Record<keyof ImportRegelDto, string>;

export const ImportRegelFieldNames: ImportRegelFieldType = {
    maxZuordnungsAenderungen: 'Grenzwert Zuordnungsänderungen global',
    netzverknuepfungsgrenzwert: 'Netzverknüpfungsgrenzwert pro Stadtwerk',
    limitAenderungLeistung: 'Grenzwert Änderungsleistung pro Stadtwerk',
};

export const ImportRegelFieldOrder: Array<keyof ImportRegelDto> = [
    'maxZuordnungsAenderungen',
    'netzverknuepfungsgrenzwert',
    'limitAenderungLeistung',
];
